<template>
  <div class="md:grid grid-cols-2 gap-5">
    <div class="flex flex-col justify-between">
      <div class="grid grid-cols-2 gap-4 md:gap-5">
        <div class="support-card md:h-[260px] h-[210px] bg-white">
          <div class="support-icon">
            <icon-call-question class="text-primary-2 text-[27px]" />
          </div>
          <div class="absolute bottom-[20px]">
            <h3 class="text-mobile-heading-4 md:text-heading-4 text-primary-1 mb-[8px]">
              {{ t("menu.Support.supportCall") }}
            </h3>
            <a
              v-if="info?.telephones?.length"
              :tel="info?.telephones[0]"
              :href="`tel:${info?.telephones[0]}`"
              class="block text-gray-1 text-heading-5"
            >
              {{ info?.telephones[0] }}
            </a>
          </div>
          <!-- <div class="mt-[50px]">
            <div class="text-heading-4 text-primary-1">UAE Support</div>
            <div class="text-gray-1 text-heading-5">+968 2 673 0424</div>
            <div class="text-gray-1 text-heading-5">+9682673 0424</div>
          </div> -->
        </div>
        <div class="support-card md:h-[260px] h-[210px] bg-white">
          <div class="support-icon">
            <icon-live-chat class="text-primary-2 text-[27px]" />
          </div>
          <div class="absolute bottom-[20px]">
            <h3 class="text-mobile-heading-4 md:text-heading-4 text-primary-1 mb-[8px]">
              {{ t("menu.Support.liveChat") }}
            </h3>
            <a
              :href="`https://wa.me/${replaceSpace(info?.whatsapp_number)}`"
              class="block text-gray-1 text-heading-5"
            >
              {{ info?.whatsapp_number }}
            </a>
          </div>
        </div>
      </div>
      <div
        class="bg-primary-1 md:p-10 p-5 rounded-[20px] md:h-[235px] mt-[14px] md:mt-[20px] relative overflow-hidden text-white"
        :class="[{ 'bg-primary-1': type == 2 }, { 'bg-cover h-full': bgImage }]"
        :style="{ backgroundImage: `url(${bgImage})` }"
      >
        <div v-if="type !== 2" class="shadow-box-1 max-md:hidden" />
        <div v-if="type !== 2" class="shadow-box-2 max-md:hidden" />
        <h3
          class="text-mobile-heading-2 md:text-heading-2 mb-[15px] text-white"
          :class="{ 'text-white': type == 2 }"
        >
          {{ t("index.followUs") }}
        </h3>
        <div
          class="text-mobile-paragraph-1 md:text-paragraph-1 mb-[20px] text-white"
          :class="{ 'text-white': type == 2 }"
        >
          {{ t("index.followUsDescription") }}
        </div>
        <div class="flex gap-6">
          <a
            v-for="item in info?.social_medias"
            :key="item.platform"
            target="_blank"
            class="cursor-pointer"
            @click="openLink(item.url)"
          >
            <component :is="dynamicIcon(item.platform)" class="text-[48px]" />
          </a>
        </div>
      </div>
    </div>
    <div class="support-card bg-white relative max-md:mt-5">
      <icon-marker
        v-if="type == 2"
        class="max-md:hidden text-transparent text-[46px] !mb-0 absolute rtl:left-2 ltr:right-4 top-[10px] md:ltr:right-[20px] ltr:scale-x-[-1] rotate-[12deg]"
      />

      <h2
        class="text-mobile-heading-3 md:text-heading-3 text-primary-1 mb-[20px]"
      >
        {{ t("index.supportDescription") }}
      </h2>
      <div
        class="md:text-paragraph-1 text-mobile-paragraph-1 mb-[80px] text-primary-1"
      >
        {{ t("index.supportSubDescription") }}
      </div>
      <div v-if="info?.address?.address_description" class="mb-5">
        <div
          class="text-primary-1 text-mobile-heading-4 md:text-heading-4 mb-[8px]"
        >
          {{ t("address.label") }}
        </div>
        <div class="text-gray-1 text-mobile-heading-5 md:text-heading-5">
          {{ info?.address?.address_description }}
        </div>
      </div>
      <hr v-if="info?.email" class="mb-5 text-gray-4" />
      <div v-if="info?.email">
        <div
          class="text-primary-1 text-mobile-heading-4 md:text-heading-4 mb-[8px]"
        >
          {{ t("payment.form.email") }}
        </div>
        <a
          class="info text-gray-1 text-mobile-heading-5 md:text-heading-5"
          :href="`mailto:${info?.email}`"
        >
          <!-- <icon-email class="" /> -->
          {{ info?.email }}
        </a>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "vue-router";
import type { ICompanyInfo } from "../../../types/general";
import { ref } from "vue";
import { useAsyncData } from "nuxt/app";
defineProps({
  type: {
    type: Number,
    default: 1,
  },
  bgImage: {
    type: String,
    default: null,
  },
});
const { t } = useI18n();
const locale = useCookie("locale").value;
const { data: info } = await useAsyncData<ICompanyInfo | null>(
  `about-${locale}`,
  () => customFetch(`api/company-info?lang=${locale}`)
);
// console.log("info.value", info.value);
const router = useRouter();
const localePath = useLocalePath();
function openLink(url: string) {
  if (!/^https?:\/\//i.test(url)) {
    url = `https://${url}`;
  }
  window.open(url, "_blank");
  // window.location.replace(url);
}
function replaceSpace(item) {
  if (!item) return "";
  return item.replace(/\s+/g, "");
}
function dynamicIcon(item: string) {
  return `icon-${item?.replace(/[\W_]+/g, "")}`;
}
</script>

<style scoped lang="scss">
.support-card {
  @apply md:p-10 p-5 rounded-[20px] shadow-2 relative;
  .support-icon {
    @apply bg-gray-4 p-3 inline-block rounded-full border border-double border-gray-3 outline outline-2 outline-gray-4;
  }
}
.shadow-box-1 {
  position: absolute;
  left: 6%;
  bottom: 0;
  width: 100px;
  height: 300px;
  border-radius: 100%;
  background: var(--primary-2-darker);
  transform: rotate(45deg);
  filter: blur(30px) drop-shadow(0 0 10px var(--primary-2));
  opacity: 0.25;
}

.shadow-box-2 {
  position: absolute;
  right: 15%;
  bottom: 0;
  width: 100px;
  height: 340px;
  transform: rotate(45deg);
  border-radius: 100%;
  background: var(--primary-2-darker);
  filter: blur(30px) drop-shadow(0 0 10px var(--primary-2));
  opacity: 0.25;
}
</style>
